import React, { useEffect, useState } from "react";

export const SLOGANS = [
  "Consistency is King",
  "Never Give Up",
  "Go Hard or Go Home",
  "Push Your Limits",
  "No Pain No Gain",
  "Become Stronger",
  "Together We Can Win",
];

export function pickSlogan() {
  return SLOGANS[Math.floor(Math.random() * SLOGANS.length)];
}

/**
 * Slogan badge — picks one at random on mount.
 * If `rotate` is true (number of ms), it cycles through slogans on an interval.
 */
export default function Slogan({ rotate = 0, className = "", testId = "slogan" }) {
  const [text, setText] = useState(() => pickSlogan());

  useEffect(() => {
    if (!rotate) return;
    const id = setInterval(() => {
      setText((current) => {
        let next = current;
        while (next === current && SLOGANS.length > 1) next = pickSlogan();
        return next;
      });
    }, rotate);
    return () => clearInterval(id);
  }, [rotate]);

  return (
    <span data-testid={testId} className={`text-xs tracking-[0.3em] uppercase text-blue-500 font-bold ${className}`}>
      {text}
    </span>
  );
}
